import { FC, useEffect, useState } from 'react';

import { useSelector } from 'src/services/redux';
import { useLazyMyProfileQuery } from '../user/api';
import { selectAccessToken } from './selectors';

export const AuthManager: FC<any> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [fetchMyProfile] = useLazyMyProfileQuery();
  const accessToken = useSelector(selectAccessToken);

  useEffect(() => {
    if (accessToken) {
      fetchMyProfile().finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  }, []);

  return isLoading ? null : children;
};
